import { createApi } from "@reduxjs/toolkit/query/react"
import { baseQuery } from "../baseQuery";

export const authApi = createApi({
    reducerPath: "authApis",
    baseQuery,
    tagTypes: ['login', 'register', "logout"],
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (body) => ({
                url: '/auth/login',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['login'],
        }),
        individualRegister: builder.mutation({
            query: (body) => ({
                url: '/auth/register',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['register'],
        }),
        me: builder.mutation({
            query: (body) => ({
                url: '/auth/me',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['login'],
        }),
        logOut: builder.mutation({
            query: (body) => ({
                url: '/auth/logout',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['logout'],
        }),
        loginViaGo: builder.mutation({
            query: (body) => ({
                url: '/auth/google/login',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['login'],
        }),
        loginViaFb: builder.mutation({
            query: (body) => ({
                url: '/auth/facebook/login',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['login'],
        }),
        loginViaGit: builder.mutation({
            query: (body) => ({
                url: '/auth/github/login',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['login'],
        }),
        forgotPassword: builder.mutation({
            query: (body) => ({
                url: '/auth/password/forgot',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['login'],
        }),
        resetPassword: builder.mutation({
            query: ({ body, query }) => ({
                url: `/auth/password/reset/${query}`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['login'],
        }),
        newUser: builder.mutation({
            query: (body) => ({
              url: `/auth/email/verify`,
              method: "POST",
              body,
            }),
            invalidatesTags: ["register"],
        }),
    })
})

export const {
    useLoginMutation,
    useLogOutMutation,
    useLoginViaGitMutation,
    useLoginViaGoMutation,
    useLoginViaFbMutation,
    useMeMutation,
    useIndividualRegisterMutation,
    useResetPasswordMutation,
    useForgotPasswordMutation,
    useNewUserMutation
} = authApi
